import ServicePageLayout from "@/components/ServicePageLayout";

export default function CommercialLeadershipPage() {
  return (
    <ServicePageLayout
      testId="page-commercial-leadership"
      eyebrow="ArcPoint Commercial"
      title="Commercial Leadership Hiring."
      intro={[
        "The people responsible for turning strategy into revenue.",
        "ArcPoint works with ambitious businesses to identify commercial leaders capable of building teams, opening markets and creating repeatable growth.",
        "Our searches are structured around the organisation's go-to-market model, commercial maturity and next stage of growth rather than job title alone.",
      ]}
      areasTitle="Revenue and commercial leadership."
      areas={[
        "Commercial Director",
        "Sales Director",
        "VP Sales",
        "VP Growth",
        "Business Development Director",
        "Revenue Leadership",
        "Strategic Partnerships",
      ]}
      deepTitle="Built around your GTM."
      deepBody={[
        "A commercial leadership search starts with understanding how the business actually intends to grow.",
        "Market, product, sales motion, team structure, funding stage and revenue expectations all influence the profile required.",
        "ArcPoint maps the market around those realities before approaching the operators most capable of delivering against them.",
      ]}
      ctaLabel="Discuss your next commercial hire"
    />
  );
}
